import { render, staticRenderFns } from "./PaidPaymentInvoice.vue?vue&type=template&id=2330dfbd&scoped=true&"
import script from "./PaidPaymentInvoice.vue?vue&type=script&lang=js&"
export * from "./PaidPaymentInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PaidPaymentInvoice.vue?vue&type=style&index=0&id=2330dfbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330dfbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VSpacer})
